export default {
  status: {
    pending: 'Odotetaan DNS:ää',
    verified: 'Live',
    failed: 'Toimenpide vaaditaan',
  },
  summary: {
    preparing:
      'Tietueet kohteelle {{host}} ovat valmisteilla. Ne näkyvät tässä noin 15 minuutin kuluessa — tai heti, kun painat Tarkista uudelleen.',
    pending:
      'Odotetaan alla olevia DNS-tietueita. Tämä kestää yleensä muutaman minuutin ja voi kestää jopa 48 tuntia — tarkistamme asiaa itse jatkuvasti.',
    certificate_pending:
      'Tietueet ovat kunnossa. Sertifikaattia kohteelle {{host}} myönnetään parhaillaan — tämä kestää yleensä muutaman minuutin.',
    verified: 'Verkkokauppa on live-tilassa osoitteessa {{host}}.',
    serving: 'Verkkokauppa on live-tilassa osoitteessa {{serving_host}}, mutta {{host}} itse ei vielä avaa sitä.',
    apex_elsewhere:
      'A-tietue kohdassa @ ei vielä osoita kauppaan. Jos {{host}} näyttää verkkosivuston, jonka pitäisi pysyä siellä, jätä @ ennalleen — kauppa toimii osoitteessa {{serving_host}}. Muussa tapauksessa lisää alla oleva A-tietue.',
    apex_held:
      '{{host}} on toisen Vercel-verkkosivuston käytössä. Jotta {{host}} avaisi myös kaupan, poista verkkotunnus ensin kyseiseltä sivustolta.',
    regressed:
      '{{host}} toimi aiemmin, mutta alla oleva tietue ei enää täsmää. Korjaa se DNS-palveluntarjoajalla ja paina sitten Tarkista uudelleen.',
    record_elsewhere:
      'Alla oleva tietue osoittaa muualle. Muuta se DNS-palveluntarjoajalla näytettyyn arvoon ja paina sitten Tarkista uudelleen.',
    records_missing:
      'Alla olevia tietueita ei edelleenkään löydy 48 tunnin jälkeen. Tarkista, että ne tallennettiin kohteelle {{zone}} sillä palveluntarjoajalla, joka hallinnoi sen DNS:ää. Jos kyseinen palveluntarjoaja ei salli muutosta, verkkotunnus saattaa olla lukittu siellä.',
    certificate: {
      ownership_proof_required:
        '{{host}} on yhdistetty myös toiseen Vercel-tiliin, joten ravintolan on todistettava, että verkkotunnus on sen omistuksessa.',
      held_by_another_project:
        '{{host}} on edelleen toisen verkkosivuston käytössä Vercelissä, joten kauppa ei voi vielä käyttää sitä.',
      dns_correct_but_unconfigured: 'Tietueet ovat oikein, mutta jokin muu kohteessa {{host}} estää sertifikaatin.',
      name_mismatch: '{{host}} vastaa edelleen toisen nimen sertifikaatilla.',
      expired: 'Sertifikaatti kohteelle {{host}} on vanhentunut. Meille on ilmoitettu ja hoidamme asiaa.',
      expiring: 'Sertifikaatti kohteelle {{host}} vanhenee pian, eikä sitä ole vielä uusittu. Hoidamme asiaa.',
      attach_refused:
        'Hosting-palveluntarjoajamme kieltäytyi lisäämästä kohdetta {{host}} meidän puoleltamme. Meille on ilmoitettu ja hoidamme asiaa.',
      overdue: 'Sertifikaattia kohteelle {{host}} ei ole edelleenkään myönnetty 48 tunnin jälkeen.',
      unknown: 'Sertifikaattia kohteelle {{host}} ei voitu myöntää.',
    },
    certificate_see_row: 'Alla oleva sertifikaattirivi kertoo, mitä tehdä.',
  },
  instructions: {
    title: 'Näin yhdistät kohteen {{host}}',
    step_provider:
      'Kirjaudu sisään palveluun, jossa kohteen {{zone}} DNS:ää hallinnoidaan — yleensä yritykseen, josta verkkotunnus ostettiin.',
    step_add: 'Lisää jokainen alla oleva tietue täsmälleen näytetyllä tavalla: sen tyyppi, nimi ja arvo.',
    step_check: 'Tallenna ja paina sitten {{button}}. Tarkistamme asiaa myös itse jatkuvasti.',
    tip_name:
      'Useimmat palveluntarjoajat haluavat nimikenttään vain osan ennen kohdetta {{zone}} — tässä {{names}}. Myös koko nimi näytetään niille palveluntarjoajille, jotka sitä vaativat.',
    tip_apex: '@ tarkoittaa itse kohdetta {{zone}}. Jotkut palveluntarjoajat jättävät nimen sen sijaan tyhjäksi.',
    tip_apex_website:
      'Jos {{zone}} avaa jo verkkosivuston, @-osoittaminen kauppaan siirtää kohteen {{zone}} pois kyseiseltä sivustolta. Jotta verkkosivusto pysyy siellä, jätä @-tietueet ennalleen — kauppa toimii silti osoitteessa www.{{zone}} — tai yhdistä sen sijaan kauppaan alatunnus, kuten order.{{zone}}.',
    tip_existing:
      'Poista kaikki muut A-, AAAA- tai CNAME-tietueet kohteesta {{name}}. Kaksi eri paikkaan osoittavaa tietuetta saa kaupan latautumaan vain osan ajasta.',
    tip_cloudflare:
      'Aseta nämä tietueet Cloudflarella tilaan Vain DNS (harmaa pilvi). Proxyn ollessa päällä kukaan ei näe, mihin ne osoittavat, eikä sertifikaattia voida myöntää.',
    tip_locked:
      'Jos palveluntarjoaja ei salli näiden tietueiden lisäämistä tai muuttamista, verkkotunnus saattaa olla lukittu, tai sen DNS:ää saatetaan hallinnoida muualla. Palveluntarjoaja voi avata lukituksen tai kertoa, missä sen DNS:ää hallinnoidaan.',
  },
  records: {
    title: 'Tietueet kohteelle {{host}}',
  },
  separate_domains: {
    apex: 'Tämä verkkotunnus on vain verkkokauppaa varten: kauppa käyttää osoitteita {{zone}} ja www.{{zone}}. Verkkosivusto tarvitsee toisen nimen — kohteen {{zone}} alatunnuksen tai oman verkkotunnuksensa.',
    subdomain:
      'Tämä verkkotunnus on vain verkkokauppaa varten. Verkkosivusto voi käyttää osoitetta {{zone}} tai www.{{zone}}.',
  },
  load_error: 'Verkkotunnuksen tilaa ei voitu ladata.',
  no_access: 'Ei pääsyä tämän ravintolan verkkotunnuksen tilaan.',
  polling_stopped: 'Tämä sivu lopetti päivittymisen itsestään. Päivitä se painamalla Tarkista uudelleen.',
  buttons: {
    check_again: 'Tarkista uudelleen',
    retry: 'Yritä uudelleen',
  },
  toasts: {
    check_started: 'Tarkistetaan tietueita. Tämä voi kestää hetken.',
    check_failed: 'Tarkistusta ei voitu käynnistää. Yritä uudelleen.',
    check_too_soon: 'Tarkistettu juuri äsken. Odota hetki ennen uutta tarkistusta.',
  },
};
